import { createAppSelector, orgUserSelectors } from "./base";

import type { RootState } from "store";

export const selectCurrentOrg = createAppSelector(
  [(state: RootState) => state.orgs],
  (orgs) => Object.values(orgs).find((o) => o.current) || null,
);

export const selectLmsType = createAppSelector([selectCurrentOrg], (org) => org?.lms_type || null);

export const selectCurrentOrgName = createAppSelector(
  [selectCurrentOrg],
  (org) => org?.name || null,
);

export const selectDisabledUserIds = createAppSelector(
  [orgUserSelectors.selectAll],
  (orgUsers) => new Set(orgUsers.filter((ou) => ou.is_disabled).map((ou) => ou.user_id)),
);

export const selectOrgUserByUserIdMap = createAppSelector(
  [orgUserSelectors.selectAll, selectCurrentOrg],
  (orgUsers, currentOrg) =>
    Object.fromEntries(
      orgUsers.filter((ou) => ou.org_id === currentOrg?.id).map((ou) => [ou.user_id, ou]),
    ),
);

export const selectCurrentOrgRole = createAppSelector(
  [orgUserSelectors.filterForCurrentUser],
  (orgUsers) => orgUsers[0]?.role || null,
);

export const selectOrgRoleByUserId = createAppSelector(
  [orgUserSelectors.selectAll, (state, userId: string) => userId],
  (orgUsers, userId) => {
    const orgUser = orgUsers.find((ou) => ou.user_id === userId);
    return orgUser?.role || null;
  },
);

export const selectOrgUserByUserId = createAppSelector(
  [selectOrgUserByUserIdMap, (state, userId: string) => userId],
  (orgUserMap, userId) => orgUserMap[userId] || null,
);

export const selectIsOrgUserDisabled = createAppSelector(
  [selectOrgUserByUserId],
  (orgUser) => orgUser?.is_disabled || false,
);

export const selectMaxAvActiveParticipants = createAppSelector(
  [selectCurrentOrg],
  (org) => org?.max_av_active_participants || 15,
);
